import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
// eslint-disable-next-line jira/import-whitelist -- error reporting is not on the resource allow list; matches every other router-resource
import { trackFetchErrors } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import type { RfoBannerSettings } from './RfoBannerSettings.types.tsx';

const PACKAGE_NAME = '@jira/router-resources__rfo-announcement-banner' as const;

/**
 * Deliberately distinct from the admin banner's `announcementBannerDismissedLast`: dismissing the
 * RFO banner must never dismiss the admin banner, or vice versa.
 */
const key = 'rfoAnnouncementBannerDismissedLast';

export const get = async (accountId: string | null): Promise<string | null> => {
	try {
		return accountId != null
			? (
					await getUserProperty<{
						hashId: string;
					}>(accountId, key)
				).hashId
			: null;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// 404 - property has not been previously set
		if (error.statusCode === 404) {
			return null;
		}

		trackFetchErrors({
			error,
			id: 'rfoUserDismissGet',
			packageName: PACKAGE_NAME,
		});
		throw error;
	}
};

export const set = async (
	accountId: string,
	hashId: RfoBannerSettings['hashId'],
): Promise<void> => {
	try {
		return await setUserProperties(accountId, key, JSON.stringify({ hashId }));
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		trackFetchErrors({
			error,
			id: 'rfoUserDismissSet',
			packageName: PACKAGE_NAME,
		});
		throw error;
	}
};

export const rfoBannerDismissalUserProperty: {
	get: (accountId: string | null) => Promise<string | null>;
	set: (accountId: string, hashId: RfoBannerSettings['hashId']) => Promise<void>;
} = {
	get,
	set,
};
